import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const PhotosIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="photos" ref={ref} {...props}>
      <path d="M16,18.69H5a2.75,2.75,0,0,1-2.75-2.75V5A2.75,2.75,0,0,1,5,2.23H16A2.76,2.76,0,0,1,18.72,5v11A2.76,2.76,0,0,1,16,18.69ZM5,3.73A1.25,1.25,0,0,0,3.77,5v11A1.25,1.25,0,0,0,5,17.19H16a1.25,1.25,0,0,0,1.25-1.25V5A1.25,1.25,0,0,0,16,3.73ZM21.73,18V6a.75.75,0,1,0-1.5,0V18A2.25,2.25,0,0,1,18,20.2H6a.75.75,0,0,0,0,1.5H18A3.75,3.75,0,0,0,21.73,18ZM8,6.84a1.15,1.15,0,1,0,0,2.3,1.15,1.15,0,0,0,0-2.3ZM6,15.42h8.83c.49,0,.65,0,.65-.27V11.53A15.27,15.27,0,0,0,14,9.94a1.07,1.07,0,0,0-1.39-.09c-.46.31-1.61,1.36-2.06,1.71a1,1,0,0,1-1.28,0c-.42-.26-.74-.45-1.25,0s-2.44,2.27-2.44,2.27V15C5.55,15.2,5.55,15.42,6,15.42Z" />
    </Icon>
  ),
) as IconWithRender;

PhotosIcon.displayName = 'PhotosIcon';
PhotosIcon.renderIcon = (props) => <PhotosIcon {...props} />;
export default PhotosIcon;
